import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Button, Row, TextBody } from '../../atoms';
import { useModal } from '../../pages';
import { PerformanceSettingsPrompt } from './performance-settings-prompt';
export default function ComponentWeb({ performanceIn, setPerformanceIn, trackPerformanceInClicked, disabled, }) {
    const { Modal, open, close } = useModal();
    const onPerformanceInPressed = useCallback(() => {
        if (trackPerformanceInClicked) {
            trackPerformanceInClicked();
        }
        open({
            title: 'Performance Settings',
            subtitle: 'Choose how you would like to view performance of your holdings',
            Body: (_jsx(PerformanceSettingsPrompt, { onSave: val => {
                    setPerformanceIn(val);
                    close();
                } })),
        });
    }, [trackPerformanceInClicked, open, setPerformanceIn, close]);
    return (_jsxs(_Fragment, { children: [_jsxs(Row.L, { style: $.container, children: [_jsx(TextBody, { small: true, em: true, lhFull: true, color: "secondary", style: disabled && $.disabled, children: "Performance in:" }), _jsx(Button, { icon: "ArrowDropDown", variant: "clear", size: "xs", label: performanceIn, onPress: onPerformanceInPressed, style: $.perfButton, disabled: disabled })] }), _jsx(Modal, {})] }));
}
const $ = StyleSheet.create({
    container: {
        height: 16,
        columnGap: theme.spacing['1'],
    },
    perfButton: {
        paddingLeft: 0,
        border: 'none',
    },
    disabled: {
        opacity: 0.5,
    },
});
